import Skeleton from "./Skeleton";
import './Skeleton.scss';

export default Skeleton